import { get, post } from '@core/Services/ApiService'

const enum LocalConstants {
  apiBase = '/api/account/take-a-break',
}

export const saveTakeABreak = async ({
  accountNumber,
  endDate,
}: {
  accountNumber: number
  endDate: Date
}): Promise<TakeABreakResponse> => {
  return await post({
    url: `${LocalConstants.apiBase}/commence`,
    body: { accountNumber, endDate },
  })
}

export const fetchTakeABreakDetails = async (): Promise<TakeABreakResponse> => {
  return await get<TakeABreakResponse>({ url: `${LocalConstants.apiBase}/status` })
}

// =====
// Types
// =====

interface TakeABreakResponse {
  inProgress: boolean
  endDate: Date
}
